/**
 * 이름표.
 *
 * 진짜 회원가입이 아닙니다. 서버가 없어서 못 만듭니다.
 * 강의장 컴퓨터를 여러 명이 돌려 쓰기 때문에, 누구 작업인지만 구분하려고 둡니다.
 * 브라우저에만 저장되고 어디로도 보내지 않습니다.
 */

const KEY = "editall.nametag";

export interface NameTag {
	name: string;
	pin: string;
}

export function readNameTag(): NameTag | null {
	if (typeof window === "undefined") return null;
	try {
		const raw = window.localStorage.getItem(KEY);
		if (!raw) return null;
		const parsed = JSON.parse(raw) as NameTag;
		return parsed?.name ? parsed : null;
	} catch {
		return null;
	}
}

export function writeNameTag(tag: NameTag): void {
	window.localStorage.setItem(KEY, JSON.stringify(tag));
}

export function clearNameTag(): void {
	window.localStorage.removeItem(KEY);
}

/** 이름이 같아도 핀이 다르면 다른 사람으로 봅니다. */
export function nameTagSlug(tag: NameTag): string {
	return `${tag.name.trim()}-${tag.pin}`.replace(/\s+/g, "_");
}

export function isValidPin(pin: string): boolean {
	return /^\d{6}$/.test(pin);
}
